function SkeletonCard({ type = "card" }) {
  if (type === "checkout") {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          gap: "12px",
          marginBottom: "12px",
        }}
      >
        <div
          className="shimmer"
          style={{
            width: "64px",
            height: "64px",
            borderRadius: "10px",
            backgroundColor: "#e0e0e0",
          }}
        />
        <div style={{ flex: 1 }}>
          <div
            className="shimmer"
            style={{
              height: "14px",
              width: "80%",
              borderRadius: "8px",
              backgroundColor: "#e0e0e0",
            }}
          />
          <div
            className="shimmer mt-1"
            style={{
              height: "12px",
              width: "60%",
              borderRadius: "8px",
              backgroundColor: "#e0e0e0",
              marginTop: "6px",
            }}
          />
        </div>
      </div>
    );
  }

  if (type === "productDetail") {
    return (
      <div className="product-details-container d-md-flex my-5">
        <div
          className="shimmer me-3"
          style={{
            width: "100%",
            maxWidth: "400px",
            height: "500px",
            borderRadius: "14px",
            backgroundColor: "#e0e0e0",
          }}
        />
        <div className="product-info-container" style={{ flex: 1 }}>
          <div
            className="shimmer"
            style={{
              height: "26px",
              width: "50%",
              marginBottom: "10px",
              borderRadius: "6px",
              backgroundColor: "#e0e0e0",
            }}
          />
          <div
            className="shimmer"
            style={{
              height: "20px",
              width: "30%",
              marginBottom: "20px",
              borderRadius: "6px",
              backgroundColor: "#e0e0e0",
            }}
          />
          <div
            className="shimmer"
            style={{
              height: "14px",
              width: "80%",
              marginBottom: "8px",
              borderRadius: "6px",
              backgroundColor: "#e0e0e0",
            }}
          />
          <div
            className="shimmer"
            style={{
              height: "14px",
              width: "90%",
              marginBottom: "8px",
              borderRadius: "6px",
              backgroundColor: "#e0e0e0",
            }}
          />
          <div
            className="shimmer"
            style={{
              height: "44px",
              width: "140px",
              marginTop: "20px",
              borderRadius: "8px",
              backgroundColor: "#e0e0e0",
            }}
          />
        </div>
      </div>
    );
  }

  // Default: product card skeleton
  return (
    <div className="col-6 col-md-4 col-lg-3 mb-2">
      <div className="card border-0 p-2 skeleton-card">
        <div
          className="shimmer"
          style={{
            borderRadius: "14px",
            height: "0",
            paddingBottom: "125%", // simulate aspect ratio
            backgroundColor: "#e0e0e0",
            position: "relative",
            overflow: "hidden",
          }}
        />
        <div
          className="shimmer mt-2"
          style={{
            height: "14px",
            width: "80%",
            borderRadius: "8px",
            backgroundColor: "#e0e0e0",
          }}
        />
        <div
          className="shimmer mt-1"
          style={{
            height: "12px",
            width: "50%",
            borderRadius: "8px",
            backgroundColor: "#e0e0e0",
          }}
        />
      </div>
    </div>
  );
}

export default SkeletonCard;
